// TODO: refactor — replace VideoPreviewModal with a new TS modal component
import VideoPreviewModal from '@/components/VideoPreviewModal/VideoPreviewModal'

import { TUTORIAL_VIDEO_URL } from './video-tutorial-modal.constants'

interface VideoTutorialModalProps {
  onClose: VoidFunction
}

export const VideoTutorialModal = ({ onClose }: VideoTutorialModalProps) => {
  return <VideoPreviewModal handleCloseVideo={onClose} videoUrl={TUTORIAL_VIDEO_URL} />
}
